<template>
  <div class="bannerImg">
    <div class="image">
      <img
        :src="imgUrl"
        alt="">
    </div>
    <div class="text-box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
/**
 * @author  XuHongli
 * @date  2022/12/22 17:57
 * @version 1.0
 * @description
 */
export default {
  props: {
    imgUrl: {
      type: String,
      default: process.env.VUE_APP_STATIC_FILE_URL + '/mp/BannerImage/newRetail-banner.jpg'
    },
  },
  name: 'BannerImg'
}
</script>

<style scoped lang="scss">
.bannerImg{
  position: relative;
  .image{
    width: 100%;
    min-width: 1280px;
    object-fit: cover;
    pointer-events: none;
    img{
      width: 100%;
      max-width: 100%;
      height: auto;
    }
  }

  .text-box {
    position: absolute;
    top: 50%;
    width: 1440px;
    left: 50%;
    transform: translate(-50%, -50%);

    .title {
      font-size: 36px;
      font-family: Microsoft YaHei-Regular,Microsoft YaHei,serif;
      font-weight: 400;
      color: #333;
    }

    .desc {
      width: 558px;
      font-size: 18px;
      font-family: Microsoft YaHei-Regular,Microsoft YaHei,serif;
      font-weight: 400;
      color: #666;
      line-height: 25px;
      margin-top: 25px;
    }
  }
}

</style>
